import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-905875ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-modal df vertical df-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_config_provider, { locale: $setup.zhCN }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              ($setup.loading.status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString($setup.loading.msg), 1),
                      _createVNode(_component_a_spin, { size: "large" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_KeepAlive, { exclude: ['machineRepairProcess'] }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _: 1
  }))
}